import { Button } from "@mui/material";
import React from "react";

interface TranslationButtonsProps {
  onClick?: (type: any, field: any) => void;
  field: any;
}

const TranslationButtons = ({ onClick = () => {}, field }: TranslationButtonsProps) => {
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ height: 18, fontSize: 8, margin: 0 }}
        onClick={() => onClick("add", field)}
      >
        Add
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        style={{ marginLeft: 4, height: 18, fontSize: 8 }}
        onClick={() => onClick("view", field)}
      >
        View
      </Button>
    </>
  );
};

export default TranslationButtons;
